import React, { useEffect, useState } from 'react';
import { Box, Button, Container, FormControl, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import TextField from '@mui/material/TextField';
import { useStore } from '../store/context';

const ConfigPage = observer((): JSX.Element => {
  const { configStore } = useStore();

  const [error, setError] = useState(false);
  const [period, setPeriod] = useState(0);

  const updatePointsValidity = () => {
    const oldPeriod = configStore?.pointsValidityInMonths;
    if (!oldPeriod || oldPeriod < period) {
      configStore?.updatePointsValidityInMonths(period);
      setError(false);
    } else {
      setError(true);
    }
  };

  useEffect(() => {
    setPeriod(configStore?.pointsValidityInMonths ?? 0);
  }, []);

  return (
    <>
      <Container sx={{ marginLeft: '15%', width: '100%' }}>
        <Box component="main" sx={{ bgcolor: 'background.default', p: 3 }}>
          <Typography variant="h4">Einstellungen für die App</Typography>
          <FormControl fullWidth sx={{ m: 1 }}>
            <TextField
              id="knaufnow"
              label="Knauf NOW"
              variant="outlined"
              value={configStore?.linkToKnaufNow}
              sx={{ m: 1 }}
              onChange={e => configStore?.updateLinkToKnaufNow(e.target.value)}
            />
            <TextField
              id="systemfinder"
              label="Systemfinder"
              variant="outlined"
              value={configStore?.linkToSystemFinder}
              sx={{ m: 1 }}
              onChange={e =>
                configStore?.updateLinkToSystemFinder(e.target.value)
              }
            />
            <TextField
              id="Datenschutz"
              label="Datenschutz"
              variant="outlined"
              value={configStore?.linkToDataPrivacy}
              sx={{ m: 1 }}
              onChange={e =>
                configStore?.updateLinktoDataPrivacy(e.target.value)
              }
            />
            <TextField
              id="Brandschutz-Folder"
              label="Brandschutz-Folder"
              variant="outlined"
              value={configStore?.fireSafetyFolder}
              sx={{ m: 1 }}
              onChange={e =>
                configStore?.updateLinktoFireSafetyFolder(e.target.value)
              }
              helperText="Ordner mit / trennen"
            />
            <TextField
              id="Maexchen-Info"
              label="Mäxchen-Info"
              variant="outlined"
              value={configStore?.linkToMaexchenInfo}
              sx={{ m: 1 }}
              onChange={e =>
                configStore?.updateLinkToMaexchenInfo(e.target.value)
              }
            />
            <TextField
              id="report"
              label="Email Adresse für Mäxchen Meldefunktion"
              variant="outlined"
              value={configStore?.reportEmailAddress}
              sx={{ m: 1 }}
              onChange={e =>
                configStore?.updateReportMailAddress(e.target.value)
              }
            />
            <Box style={{ display: 'flex' }}>
              <TextField
                id="report"
                label="Zeitraum für Gültigkeit von Mäxchen in Monaten"
                variant="outlined"
                value={period}
                sx={{ m: 1, width: '90%' }}
                type="number"
                helperText={error ? 'Wert muss größer als zuvor sein!' : ''}
                onChange={e => setPeriod(Number(e.target.value))}
                FormHelperTextProps={{
                  style: { color: 'red' },
                }}
              />
              <Button onClick={updatePointsValidity}>Speichern</Button>
            </Box>
          </FormControl>
        </Box>
      </Container>
    </>
  );
});

export default ConfigPage;
